export const INVITE_TIME_TYPES = ['1', '2', '3', '4']
export const COMMISSION_WEEK_DIFFS = ['0', '1', '2', '3']
export const TIME_TABS_INVITE = [
  { key: 'thisWeek', labelKey: 'lang.Invite.k105' },
  { key: 'lastWeek', labelKey: 'lang.Invite.k106' },
  { key: 'today', labelKey: 'lang.Invite.k074' },
  { key: 'yesterday', labelKey: 'lang.Invite.k075' },
]
export const INVITE_DATA_TYPE = {
  ALL: '1',
  NEW_SUB_AGENT: '2',
  PERFORMANCE: '3',
}
export const PREVIEW_FETCH_LIMIT = 4
export const PREVIEW_DISPLAY_LIMIT = 3
export const LIST_PAGE_SIZE = 15
export function getInviteTimeType(tabIndex) {
  return INVITE_TIME_TYPES[tabIndex] || INVITE_TIME_TYPES[0]
}
export function getCommissionWeekDiff(tabIndex) {
  return COMMISSION_WEEK_DIFFS[tabIndex] || COMMISSION_WEEK_DIFFS[0]
}
export function mapSubAgentStatItem(item, formatDate) {
  return {
    presentId: item.presentId || '',
    nickname: item.nickName || '',
    locationFlag: item.locationImg || '',
    joined: formatDate ? formatDate(item.becomeSubAgentTime) : item.becomeSubAgentTime,
    totalHostess: item.cumulativeInviteCount ?? 0,
    newHostess: item.inviteCount ?? 0,
  }
}
export function mapCommissionItem(item) {
  const income = item.hostCommission ?? 0
  const commission = item.agentCommission ?? 0
  return {
    presentId: item.presentId || '',
    nickname: item.nickName || '',
    locationFlag: item.locationImg || '',
    income,
    commission,
    inactive: income === 0 && commission === 0,
  }
}
export function buildInviteParams({ timeTabIndex, dataType, offset = 0, limit = LIST_PAGE_SIZE, presentId = '' }) {
  const params = {
    timeType: getInviteTimeType(timeTabIndex),
    dataType,
    offset: String(offset),
    limit: String(limit),
  }
  if (presentId) {
    params.presentId = presentId
  }
  return params
}
export function buildCommissionParams({ timeTabIndex, offset = 0, limit = LIST_PAGE_SIZE, presentId = '' }) {
  const params = {
    weekDiff: getCommissionWeekDiff(timeTabIndex),
    offset: String(offset),
    limit: String(limit),
  }
  if (presentId) {
    params.presentId = presentId
  }
  return params
}

export function formatCarouselTimeLabel(timestamp, now = Date.now()) {
  if (!timestamp) {
    return { langKey: 'lang.Invite.k110', numsOption: [] }
  }
  const diffMs = now - timestamp
  if (diffMs < 3600000) {
    return { langKey: 'lang.Invite.k110', numsOption: [] }
  }
  const eventDay = new Date(timestamp)
  const yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)
  if (
    eventDay.getFullYear() === yesterday.getFullYear() &&
    eventDay.getMonth() === yesterday.getMonth() &&
    eventDay.getDate() === yesterday.getDate()
  ) {
    return { langKey: 'lang.BaseModule.k077', numsOption: [] }
  }
  const hours = Math.max(1, Math.floor(diffMs / 3600000))
  return { langKey: 'lang.Invite.k112', numsOption: [{ value: hours }] }
}

export function mapCarouselItem(item, now = Date.now()) {
  const type = item.type === 1 ? 1 : 2
  return {
    timeLabel: formatCarouselTimeLabel(item.time, now),
    messageLangKey: type === 1 ? 'lang.Invite.k109' : 'lang.Invite.k111',
    messageNumsOption: [{ value: item.nickName || '' }],
  }
}

export function mapCarouselList(list, now = Date.now()) {
  return (list || []).map((item) => mapCarouselItem(item, now))
}
